import type { ReactNode } from 'react';
import { Alert } from '@mui/material';
import { useCan } from './PermissionProvider';

export function PermissionGate({ scopeBase, children }: { scopeBase: string; children: ReactNode }) {
  return useCan(scopeBase, 'read') ? <>{children}</> : <Alert severity="warning">You do not have access to this area.</Alert>;
}
